import { useEffect } from 'react';
import { fetchClientConfig } from '../../api/auth';

declare global {
  interface Window {
    chatwootSettings?: {
      hideMessageBubble?: boolean;
      position?: 'left' | 'right';
      locale?: string;
      type?: 'standard' | 'expanded_bubble';
      launcherTitle?: string;
    };
    chatwootSDK?: {
      run: (config: { websiteToken: string; baseUrl: string }) => void;
    };
    $chatwoot?: {
      toggle: (state?: 'open' | 'close') => void;
      setCustomAttributes: (attrs: Record<string, string>) => void;
      setLabel: (label: string) => void;
      reset: () => void;
    };
  }
}

const ChatwootWidget: React.FC = () => {
  useEffect(() => {
    let cancelled = false;

    fetchClientConfig().then((config) => {
      if (cancelled) return;

      const baseUrl = config.chatwoot_base_url;
      const token = config.chatwoot_website_token;
      if (!baseUrl || !token) return;

      window.chatwootSettings = {
        hideMessageBubble: false,
        position: 'right',
        locale: 'en',
        type: 'standard',
        launcherTitle: 'Chat with us',
      };

      const script = document.createElement('script');
      script.src = `${baseUrl}/packs/js/sdk.js`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        window.chatwootSDK?.run({
          websiteToken: token,
          baseUrl: baseUrl,
        });
      };

      document.head.appendChild(script);
    }).catch(() => {
      // Config fetch failed — skip Chatwoot initialization
    });

    return () => {
      cancelled = true;
      const bubble = document.querySelector('.woot-widget-bubble');
      const holder = document.querySelector('.woot-widget-holder');
      if (bubble) (bubble as HTMLElement).style.display = 'none';
      if (holder) (holder as HTMLElement).style.display = 'none';
      window.$chatwoot?.reset();
    };
  }, []);

  return null;
};

export default ChatwootWidget;
